export default __webpack_public_path__ + "static/media/Rastadick.96cdc538.png";